import React, { useState, useEffect } from 'react';
import SubmitStrategyModal from './SubmitStrategyModal';

// Webhook URL - Make.com webhook
const WEBHOOK_URL = 'https://hook.eu1.make.com/wjfjhbmkpn26rphbijm8e7sat816e6yq';

interface SubmitStrategyPageProps {
  isOpen: boolean;
  onClose: () => void;
}

const SubmitStrategyPage: React.FC<SubmitStrategyPageProps> = ({ isOpen, onClose }) => {
  const [strategy, setStrategy] = useState({
    name: '',
    difficulty: 'medium',
    cost: 'medium',
    description: ''
  });
  
  const [pinnedContentTypes, setPinnedContentTypes] = useState<string[]>([]);
  const [notification, setNotification] = useState<{ message: string; type: 'success' | 'error' } | null>(null);

  // Load current strategy and pinned content types from localStorage
  useEffect(() => {
    if (isOpen) {
      try {
        // Load strategy
        const savedStrategy = localStorage.getItem('atlasStrategy');
        if (savedStrategy) {
          setStrategy(JSON.parse(savedStrategy));
        }
        
        // Load pinned content types
        const savedContentTypes = localStorage.getItem('pinnedContentTypes');
        if (savedContentTypes) {
          const types = JSON.parse(savedContentTypes);
          setPinnedContentTypes(Array.isArray(types) ? types : []);
        } else {
          // Try fallback to single content type
          const singleType = localStorage.getItem('pinnedContentType');
          if (singleType) {
            try {
              const type = JSON.parse(singleType);
              setPinnedContentTypes(type ? [type] : []);
            } catch {
              setPinnedContentTypes([]);
            }
          } else {
            setPinnedContentTypes([]);
          }
        }
      } catch (err) {
        console.error('Failed to load strategy or content types:', err);
      }
    }
  }, [isOpen]);

  // Handle successful submission
  const handleSubmitSuccess = (message: string) => {
    setNotification({
      message,
      type: 'success'
    });
    
    // Clear notification after 3 seconds
    setTimeout(() => {
      setNotification(null);
    }, 3000);
  };

  return (
    <>
      <SubmitStrategyModal
        isOpen={isOpen}
        onClose={onClose}
        strategy={strategy}
        pinnedContentTypes={pinnedContentTypes}
        webhookUrl={WEBHOOK_URL}
        onSubmitSuccess={handleSubmitSuccess}
      />
      
      {/* Notification */}
      {notification && (
        <div 
          className={`fixed top-4 right-4 px-4 py-2 rounded shadow-lg z-50 ${
            notification.type === 'success' ? 'bg-green-500' : 'bg-red-500'
          } text-white`}
        >
          {notification.message}
        </div>
      )}
    </>
  );
};

export default SubmitStrategyPage;